angular.module('leanlaw').directive('llAlert', [function () {
  return {
    restrict: "E",
    replace: true,
    template: require("./views/llAlert.html"),
    scope: {
      alert: "=alertInstance"
    },
    link: $scope => {
      $scope.closeAlert = function closeAlert(e) {
        e.stopPropagation();
        $scope.alert.dismiss();
      };
      $scope.clickAlert = function clickAlert() {
        $scope.alert.click();
      };
    }
  };
}]);